import { Component } from '@angular/core';
import * as _ from 'lodash';
import { FormSessionCanDeactivate, PatientService, UserService } from '../shared';
import { User } from '../shared/models/user.model';


@Component({
  selector: 'app-cnmapping',
  templateUrl: './cnmapping.component.html',
  styleUrls: ['./cnmapping.component.css']
})
export class CnmappingComponent extends FormSessionCanDeactivate {
  dtOptions: any = {};
  currentUser: User;
  SurgeonList: any;
  ProceduretypeList: any;
  PayorIdList: any;
  patientConfig: any;
  surgeon: any = "";
  payerType: any = "";
  hospitalId: any = "";
  procedureType: any = "";
  hospitalList: any;

  constructor(private userService: UserService, private patientService: PatientService) {
    super();
  }

  ngOnInit() {

    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      });

    if (this.currentUser.item) {
      this.getHospitalLsit(this.currentUser.item.userAccountId);
      this.getSurgeonList(this.currentUser.item.userAccountId);
      this.getProceduretypeList(this.currentUser.item.userAccountKey);
      this.getPayorIdList(this.currentUser.item.userAccountKey);
      this.getPatientsConfig(this.currentUser.item.userAccountKey, this.currentUser.item.userAccountId);
    }
    this.setDtConfig()
  }

  setDtConfig() {
    this.dtOptions = {
      pageLength: 10,
      searching: true,
      lengthChange: true,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]
    };
  }


  //get hispital list for drop down
  getHospitalLsit(userAccountId) {
    let self = this;
    self.patientService.getHospitalList(userAccountId)
      .subscribe(data => {
        self.hospitalList = _.filter(data.aaData, (o) => {
          return o.hospitalId != 10001
        })
      })
  }


  getSurgeonList(userAccountId) {
    this.userService.getSurgeonList(userAccountId)
      .subscribe(data => {

        this.SurgeonList = data;

        //console.log("Survey List", data)

      })
  }


  getProceduretypeList(userAccountKey) {
    this.userService.getProceduretypeList(userAccountKey)
      .subscribe(data => {
        this.ProceduretypeList = data;
        //console.log("Proceduretype List", data)
      })
  }


  getPayorIdList(userAccountId) {
    this.userService.getPayorIdList(userAccountId)
      .subscribe(data => {
        this.PayorIdList = data;
        //console.log("PayorId List", data)
      })
  }


  //In Patient List 
  getPatientsConfig(userAccountKey, userAccountId) {
    this.userService.getInPatientsConfig(userAccountKey, userAccountId)
      .subscribe(data => {
        this.patientConfig = data;
        //console.log("inPatientConfig", data)
      })
  }

  cnMapping: any;
  getMappingDetails() {
    this.userService.fetchCNSugProcPayer(this.surgeon, this.procedureType, this.payerType, this.hospitalId)
      .subscribe(data => {
        this.cnMapping = data.result[0];
        //console.log("CNMAppinf", data)
      })
  }


}
